// Configuration for development environment
console.log('Config loading...');
// Web-only version: no Electron detection

const isDev = process.env.NODE_ENV === 'development';

console.log('Environment:', {
  NODE_ENV: process.env.NODE_ENV,
  isDev,
  userAgent: window.navigator.userAgent
});

const apiBaseUrl = isDev ? 'http://localhost:5000/api' : 'https://sanduke-admin.onrender.com/api';

// Default values
let globalDev = false;

// Simple config object with default values
const config = {
  isDev,
  apiBaseUrl,
  devTools: globalDev,
  autoLogin: globalDev,
  enableTestData: globalDev,
  globalDev,
  // Add dev credentials for development
  devCredentials: {
    username: 'admin',
    password: 'password',
    token: 'dev-token-123',
    userId: 1
  }
};

// In the renderer process, we'll get config from the main process (not used in web version)
const initConfig = async () => {
  // Electron config not supported in web version
  // No Electron config in web version
  // This block is left for compatibility but does nothing in web version
  console.warn('Running in browser mode, using default config');
};

// Initialize config
initConfig();

export default config;
